import React from 'react';
import './styles.scss';
import { APP_TEXTS } from '../../../../texts/texts';
import { connect } from 'react-redux';
import { setFEMOptimization, startFEMCalculation, cancelFEMCalculation, setFEMOptions } from '@reducers/selectors/calculate/actions';
import { defaultUnits } from '@config';
import { Table, Progress } from 'reactstrap';
import { unitLabel, unitTransform, prepareNum } from '@services/helper.service';

class CalculateThickness extends React.Component {

  render() {
    return (
      <div className="calculation">
      <section className="list-type">
        <p>{APP_TEXTS.CALCULATE_THICKNESS_DESCRIPTION.Content}
        </p>

        <div className="form-check">
          <label className="form-check-label" htmlFor="optimizePlateThickness">
            <input 
              className="form-check-input mt-0" 
              type="checkbox" 
              id="optimizePlateThickness" 
              checked={this.props.FEM.optimizePlateThickness}
              onChange={(e) => { this.props.setFEMOptimization(e.target.checked); }}
            />
            {APP_TEXTS.CALCULATE_PLATE_THICKNESS_OPTIMIZATION.Content}
          </label>
        </div>
      
      {this.props.companyName === "SPIT_JHGZE%2_Val" && (
        <div className="form-check">
          <label className="form-check-label mt-2 mb-2" htmlFor="overrideFEMDefault">
            <input 
              className="form-check-input"
              type="checkbox"
              id="overrideFEMDefault"
              checked={this.props.FEM.FEMOptions.overrideDefault}
              onChange={(e) => { this.props.setFEMOptions({ overrideDefault: e.target.checked }); }}
            />
            <span>Override FEM default values</span>
          </label>
          <div>
            <input
              className="m-2"
              type="number"
              id="meshStep"
              value={this.props.FEM.FEMOptions.meshStep}
              onChange={(e) => { this.props.setFEMOptions({ meshStep: e.target.value }); }}
            />
            <span>Mesh step (Default: 2 * plate thickness in mm)</span>
          </div>
          <div>
            <input
              className="m-2"
              type="number"
              id="anchorRigidity"
              value={this.props.FEM.FEMOptions.anchorRigidity}
              onChange={(e) => { this.props.setFEMOptions({ anchorRigidity: e.target.value }); }}
            />
            <span>Anchor rigidity (Default: 15000)</span>
          </div>
          <div>
            <input
              className="m-2"
              type="number"
              id="plateThicknessStep"
              value={this.props.FEM.FEMOptions.plateThicknessStep}
              onChange={(e) => { this.props.setFEMOptions({ plateThicknessStep: e.target.value }); }}
            />
            <span>Plate thickness step (Default: 2)</span>
          </div>
          <div>
            <input
              className="m-2"
              type="number"
              id="maximumDisplacementRatio"
              value={this.props.FEM.FEMOptions.maximumDisplacementRatio}
              onChange={(e) => { this.props.setFEMOptions({ maximumDisplacementRatio: e.target.value }); }}
            />
            <span>Maximum displacement ratio (Default: 0.333; 1.0 for axial force)</span>
          </div>
          <div>
            <input
              className="m-2"
              type="number"
              id="maximumDisplacement"
              value={this.props.FEM.FEMOptions.maximumDisplacement}
              onChange={(e) => { this.props.setFEMOptions({ maximumDisplacement: e.target.value }); }}
            />
            <span>Maximum displacement (Default: 10)</span>
          </div>
          <div>
            <input
              className="m-2"
              type="number"
              id="maximumStress"
              value={this.props.FEM.FEMOptions.maximumStress}
              onChange={(e) => { this.props.setFEMOptions({ maximumStress: e.target.value }); }}
            />
            <span>Maximum stress (Default: Fy value from the database)</span>
          </div>
        </div>
      )}

      <div>
      {this.props.FEM.isCalculating ? (
        <div className="fem-progress">
          <button 
            type="button" 
            className="CalculateThickness__btn"
            onClick={() => { this.props.cancelFEMCalculation();}}
          >
            {APP_TEXTS.CALCULATE_THICKNESS_CANCEL.Content}
          </button>
          <div className="progress-bar-container">
            <Progress animated value="100" />
          </div>
        </div>
      ) : (
        <React.Fragment>
          <button 
            type="button" 
            className="CalculateThickness__btn"
            onClick={() => { this.props.startFEMCalculation();}}
          >
            {APP_TEXTS.CALCULATE_THICKNESS_START.Content}
          </button>
          <section className="fem-results">
          {this.props.FEM.isValid ? (
            <Table bordered size="sm">
              <tbody>
                <tr key="recommendedPlateThickness">
                  {this.getRecommendedPlateThickness()}
                </tr>
                <tr key="basePlateThickness">
                  <th scope="row">{APP_TEXTS.CALCULATE_FEM_BASE_PLATE_THICKNESS.Content}</th>
                  <td>{unitTransform(this.props.plateThickness, true).from(defaultUnits.DISTANCE).to(this.props.distanceUnit)}</td>
                  <td>
                    {unitLabel(this.props.distanceUnit)} {this.props.FEM.optimizePlateThickness && 
                      (Math.abs(this.props.FEM.recommendedPlateThickness - this.props.plateThickness) > 1e-3 ? (
                        <span className="icon_uncheck"/>
                      ) : (
                        <span className="icon_check"/>
                      )
                    )}
                  </td>
                </tr>
                <tr key="maximumDisplacement">
                  <th scope="row">{APP_TEXTS.CALCULATE_FEM_MAXIMUM_DISPLACEMENT.Content}</th>
                  <td>
                    {prepareNum(unitTransform(this.props.FEM.maximumDisplacement, false)
                                    .from(defaultUnits.DISTANCE)
                                    .to(this.props.distanceUnit), 
                                  false, 
                                  3)}
                  </td>
                  <td>{unitLabel(this.props.distanceUnit)}</td>
                </tr>
                <tr key="relativeDisplacement">
                  <th scope="row">{APP_TEXTS.CALCULATE_FEM_RELATIVE_DISPLACEMENT.Content}</th>
                  <td>
                    {prepareNum(unitTransform(this.props.FEM.relativeDisplacement, false)
                                    .from(defaultUnits.DISTANCE)
                                    .to(this.props.distanceUnit), 
                                  false, 
                                  3)}
                  </td>
                  <td>{unitLabel(this.props.distanceUnit)}</td>
                </tr>
                <tr key="maxVonMisesStress">
                  <th scope="row">{APP_TEXTS.CALCULATE_FEM_MAX_VON_MISES_STRESS.Content}</th>
                  <td>{unitTransform(this.props.FEM.maxVonMisesStress, true).from(defaultUnits.STRENGTH).to(this.props.strengthUnit)}</td>
                  <td>{unitLabel(this.props.strengthUnit)}</td>
                </tr>
              </tbody>
            </Table>
          ) : (
            <p className="mb-0">{APP_TEXTS.THICKNESS_FEM_CALCULATION_NOT_LAUNCHED.Content}</p>
          )}
          </section>
        </React.Fragment>
      )}
      </div>

      </section>
      </div>
    );
  }

  getRecommendedPlateThickness(){
    if (this.props.FEM.optimizePlateThickness) {
      if (Math.abs(this.props.FEM.recommendedPlateThickness - this.props.plateThickness) > 1e-3) {
        if (this.props.FEM.recommendedPlateThickness < this.props.plateThickness) {
          return ( 
            <React.Fragment>
              <th scope="row">{APP_TEXTS.CALCULATE_FEM_LOWER_BASE_PLATE_THICKNESS.Content}</th>
              <td>{unitTransform(this.props.FEM.recommendedPlateThickness).from(defaultUnits.DISTANCE).to(this.props.distanceUnit)}</td>
              <td>{unitLabel(this.props.distanceUnit)} <span className="icon_check"/></td>
            </React.Fragment>
          );
        } else {
          return ( 
            <React.Fragment>
              <th scope="row">{APP_TEXTS.CALCULATE_FEM_CHANGE_PLATE_THICKNESS.Content}</th>
              <td>{unitTransform(this.props.FEM.recommendedPlateThickness).from(defaultUnits.DISTANCE).to(this.props.distanceUnit)}</td>
              <td>{unitLabel(this.props.distanceUnit)} <span className="icon_check"/></td>
            </React.Fragment>
          );
        }
      } else {
        return ( 
          <React.Fragment>
          <th scope="row">{APP_TEXTS.CALCULATE_FEM_PLATE_THICKNESS_CORRECT.Content}</th>
          <td><span className="icon_check"/></td>
          </React.Fragment>
        );
      }
    } else {
      if (this.props.FEM.structureAnalysisStatus) {
        return ( 
          <React.Fragment>
            <th scope="row">{APP_TEXTS.CALCULATE_FEM_PLATE_THICKNESS_CORRECT.Content}</th>
            <td><span className="icon_check"/></td>
          </React.Fragment>
        );
      } else {
        return ( 
          <React.Fragment>
            <th scope="row">{APP_TEXTS.CALCULATE_FEM_PLATE_THICKNESS_NOT_CORRECT.Content}</th>
            <td><span className="icon_uncheck"/></td>
          </React.Fragment>
        );
      }
    }
  }

};

const mapState = state => ({
  FEM: state.selectors.calculate[state.main.appType].FEM,
  plateThickness: state.selectors.dimension[state.main.appType].basePlate.tfix,
  distanceUnit: state.main.units.distance,
  strengthUnit: state.main.units.strength,
  companyName: state.main.userProfile.companyName
});

const mapDispatch = dispatch => ({
  setFEMOptimization: (value) => dispatch(setFEMOptimization(value)),
  setFEMOptions: (value) => dispatch(setFEMOptions(value)),
  startFEMCalculation: () => dispatch(startFEMCalculation()),
  cancelFEMCalculation: () => dispatch(cancelFEMCalculation())
});

export default connect(mapState, mapDispatch)(CalculateThickness);



// WEBPACK FOOTER //
// ./src/views/Calculate/components/CalculateThickness/CalculateThickness.js